import { AfterContentInit, Component, OnInit } from '@angular/core';
import { LoadingService } from '@wz-services';

@Component({
  selector: 'wz-remerciement',
  templateUrl: './remerciement.component.html',
  styleUrls: ['./remerciement.component.scss'],
  standalone: false,
})
export class RemerciementComponent implements OnInit, AfterContentInit {
  loading: boolean = false;

  constructor(private loadingService: LoadingService) {}

  ngOnInit() {}

  ngAfterContentInit() {
    this.loadingService.loadingSubject.next(false);
  }
}
